'use strict';

(function ($) {
	$(document).ready(function () {
		var $post_social = $('.post-social');

		if ($post_social.length > 0) {
			var $facebook_button = $('.post-social-facebook');
			var permalink = $facebook_button.attr('data-permalink');

			var getFacebookCount = function getFacebookCount() {
				$.getJSON('https://graph.facebook.com/' + permalink, function (data) {
					var facebookShares = data.share.share_count;
					if (facebookShares !== undefined) {
						$facebook_button.find('.share-count').text(facebookShares);
					}
				});
			};

			getFacebookCount();
		}
	});
})(jQuery);